/**
 * dylaras-supplier-filter.js
 * Hides internal supplier codes from customer-facing filter UI.
 * Runs on DOMContentLoaded, after AJAX filter updates, and via MutationObserver.
 */
(function () {
  var HIDDEN = ['stuller', 'jgoodin', 'Stuller', 'JGoodin', 'j goodin', 'J Goodin'];

  function hideSupplierFilters() {
    HIDDEN.forEach(function (code) {
      var lc = code.toLowerCase();

      // 1. Hide by input[value]
      document.querySelectorAll('input[value="' + code + '"], input[value="' + lc + '"]').forEach(function (input) {
        var item = input.closest('li, .facets__item, [class*="filter-item"], [class*="facet-item"]');
        if (item) item.style.display = 'none';
      });

      // 2. Hide by link[href*=supplier_code]
      document.querySelectorAll('a[href*="supplier_code=' + code + '"], a[href*="supplier_code=' + lc + '"]').forEach(function (a) {
        var item = a.closest('li, .facets__item, [class*="filter-item"]');
        if (item) item.style.display = 'none';
      });

      // 3. Hide labels/spans whose visible text exactly matches the code
      document.querySelectorAll('.facets__item label, .facets__item span, [class*="filter-item"] label, [class*="filter-item"] span').forEach(function (el) {
        if (el.children.length === 0 && el.textContent.trim().toLowerCase() === lc) {
          var item = el.closest('li, .facets__item, [class*="filter-item"]');
          if (item) item.style.display = 'none';
        }
      });
    });

    // 4. Hide an entire filter group if all its items are now hidden
    document.querySelectorAll('details[class*="facet"], .facets__disclosure, [class*="filter-group"], [class*="facets-group"]').forEach(function (group) {
      var items = group.querySelectorAll('li, .facets__item, [class*="filter-item"]');
      if (items.length > 0 && Array.from(items).every(function (i) { return i.style.display === 'none'; })) {
        group.style.display = 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', hideSupplierFilters);

  // Shopify theme AJAX filter events
  ['facets:update', 'collection:rerender', 'search:rerender'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(hideSupplierFilters, 100); });
  });

  // MutationObserver for dynamic DOM updates (drawer filters, infinite scroll, etc.)
  var observer = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (m) {
      return m.addedNodes.length > 0;
    });
    if (relevant) hideSupplierFilters();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
